"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

/**
 * Throttles calls to a function to ensure they only happen on a request animation frame.
 */
exports.default = function (fn) {
    var requestId = void 0;

    var throttled = function throttled() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        var latestArgs = args;
        // If we have already requested an animation frame, return
        if (requestId) return;

        // Wait an animation frame
        requestId = requestAnimationFrame(function () {
            requestId = null;
            fn.apply(undefined, latestArgs);
        });
    };

    throttled.cancel = function () {
        if (!requestId) return;
        cancelAnimationFrame(requestId);
        requestId = null;
    };

    return throttled;
};


//////////////////
// WEBPACK FOOTER
// ./src/common/utils/lib/rafThrottle.js
// module id = 245
// module chunks = 0